export const getSwitchboardActionState = ({editorDocId}: {editorDocId?: string | null}) => {
  const hasSwitchboard = Boolean(editorDocId);

  return {
    hasSwitchboard,
    showCreateSwitchboard: !hasSwitchboard,
  };
};
